import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { MiddlewareAPIResponse } from '../../middlewareapiresponse';

export interface DeleteGroupResponse extends MiddlewareAPIResponse
{
}

export class DeleteGroupResponseDtoImpl extends MiddlewareDtoImpl implements DeleteGroupResponse
{
   
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/group/deletegroup/deletegroupresponse.tsx